export  default {
    getLogInjections(state) {
        return state.logInjections;
    },
};